import { AuthState } from '@okta/okta-auth-js';

import { FuturesTradeAccounts } from '../../services/backend/FuturesTradeAccounts';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesTradeAccounts: () => FuturesTradeAccounts<AuthState> = () => {
  return useBaseApiClient(FuturesTradeAccounts);
};
